module.exports = __webpack_public_path__ + "assets/pdf/E12-en-working-together.d9073a58.pdf";